import { render, staticRenderFns } from "./FaqChild.vue?vue&type=template&id=05397878&scoped=true&"
import script from "./FaqChild.vue?vue&type=script&lang=js&"
export * from "./FaqChild.vue?vue&type=script&lang=js&"
import style0 from "./FaqChild.vue?vue&type=style&index=0&id=05397878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05397878",
  null
  
)

export default component.exports